var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg049Flasher = function Svg049Flasher(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 241h90v30H31zM391 241h90v30h-90zM27.659 141.502l15.002-25.984 114.207 65.939-15.003 25.984zM355.112 181.399l114.206-65.94 15.002 25.985-114.206 65.94zM130.504 79.6l25.984-15.003 54.202 93.878-25.984 15.003zM301.312 158.513l54.202-93.878 25.984 15.003-54.202 93.878zM241 0h30v181h-30zM91 452h330v60H91zM147.47 249.628 122.981 422h266.038L364.53 249.628C361.381 227.611 342.235 211 319.984 211H192.016c-22.251 0-41.397 16.611-44.546 38.628"
  })));
};
export default Svg049Flasher;